import env from '../lib/env';

var url = require('url');

const common_para = new Set(['userid', 'token', 'os', 'sv', 'sex']);

function check_login(target, name, descriptor) {
    const old_func = descriptor.value;
    descriptor.value = function () {
        return old_func.apply(this, arguments).catch(e => {
            if (e.errno === 1202) {
                env.dispatch({
                    type: 'user/show_login',
                    payload: true,
                });
            }
            throw e;
        });
    };
    return descriptor;
}

class Wandu {

    constructor(...args) {
        this.host = window.location.host;
        this.protocol = window.location.protocol;
        this.transparent_para = {};
        let res = url.parse(window.location.href, true).query;
        for (const k in res) {
            if (k.indexOf('_p_') === 0) {
                this.transparent_para[k.substr(3)] = res[k];
            }
            if (common_para.has(k)) {
                this.transparent_para[k] = res[k];
            }
        }
    }

    __get_resp(path, query, data = null, method = 'GET') {
        const uri = url.format({
            protocol: this.protocol,
            host: this.host,
            pathname: path,
            query: Object.assign({}, this.transparent_para, query),
        });
        let config = {
            mode: 'cors',
            //credentials: 'include',
            method: method,
        };
        if (method === 'POST') {
            config.headers = {
                'Content-Type': 'application/x-www-form-urlencoded',
            };
        }
        if (data) {
            let data_str = '';
            for (const k in data) {
                data_str += `${k}=${encodeURIComponent(data[k])}&`;
            }
            config.body = data_str;
        }
        return fetch(uri, config).then(res => {
            if (res.status !== 200) {
                throw res;
            }
            return res.json();
        }).then(res => {
            if (res.errno !== 0) {
                throw res;
            }
            return res.data;
        });
    }

    /*
     * utime
     */
    article_list(data) {
        return this.__get_resp('/choiceness/article_list', data);
    }

    /*
     * article_id
     */
    article_detail(data) {
        return this.__get_resp('/choiceness/article_detail', data);
    }

    /*
     * article_id
     */
    article_zan(data) {
        return this.__get_resp('/choiceness/article_zan', data);
    }


    /*
     * article_id
     */
    article_share_report(data) {
        return this.__get_resp('/choiceness/article_share', data);
    }

    /*
     * novel_id
     * page
     */
    book_rec(data) {
        return this.__get_resp('/recommend/book', data);
    }

    article_rec() {
        return this.__get_resp('/recommend/article', {})
    }

    wx_config() {
        var info = url.parse(window.location.href);
        return this.__get_resp('/wx/config', {
            url: info.host + info.path,
        });
    }

    info() {
        return this.__get_resp('/info', {});
    }

    /*
     * first_id
     */
    feedback(data) {
        return this.__get_resp('/user/feedback', {
            display: 'json',
            ...data
        });
    }

    /*
     * content
     * contact
     * pic(json_str)
     */
    do_feedback(data) {
        return this.__get_resp('/user/do_feedback', {}, data, 'POST');
    }

    user_brief() {
        return this.__get_resp('/user/brief', {});
    }

    /*
     * novel_id
     */
    get_chapter_content(data) {
        return this.__get_resp('/book/get_chapter_content', data);
    }

    /*
     * ticket
     * novel_id
     */
    get_book_coin(data) {
        return this.__get_resp('/choiceness/get_free_voucher', data);
    }

    get_award() {
        return this.__get_resp('/activity/newpersonwelfare', { display: 'json' });
    }

    do_newwelfare(data) {
        return this.__get_resp('/activity/do_newwelfare', {},
            { ...data, userid: this.transparent_para.userid, token: this.transparent_para.token },
            'POST');
    }

    /*
     * pn
     */
    act_free_list(data) {
        return this.__get_resp('/activity/free_list', data);
    }

    act_mt_zhengwen() {
        return this.__get_resp('/activities/mengtuan/get_award_info', {});
    }

    /*
     *春华支付
     *
     */
    app_pay(data) {
        return this.__get_resp('/user/app_pay', { ...data, display: 'json' })
    }

    /*
     * channel  1: home
     */
    home(data) {
        //const { channel } = data;  
        return this.__get_resp('/cg_api/home', { display: 'json', is_pc: 1 })
    }

    /*
     * type: month | week
     * num: 
     */
    top_list(data) {
        return this.__get_resp('/top/top_list', data);
    }

    /*书籍详情
     * novel_id
     */
    book_detail(data) {
        return this.__get_resp('/cg_api/book/detail', data);
    }

    /*
     * novel_id
     * order_num
     */
    book_read(data) {
        const { novel_id, order_num } = data;
        // const path = `/book/read/${novel_id}${order_num >= 0 ? '/' + order_num : ''}`;
        const path = `/cg_api/book/content`;
        return this.__get_resp(path, { display: 'json', novel_id, order_num: order_num || '1' })
            .catch(e => {
                if (!e.errno && e.novel_id) {
                    return e;
                } else {
                    throw e;
                }
            });
    }

    /*
     *  novel_id
     *  order_num
     */
    comic_book_read(data) {
        const { novel_id, order_num } = data;
        const path = `/comicbook/read/${novel_id}${order_num >= 0 ? '/' + order_num : ''}`;
        return this.__get_resp(path, { display: 'json' });
    }

    /*
     * novel_id
     * last_reply_time
     */
    book_comment(data) {
        return this.__get_resp('/api/comment/hot_comment', data);
    }

    /*
     * 章节列表 
     * novel_id
     * start
     * num
     */
    book_catalog(data) {
        return this.__get_resp('/cg_api/book/chapter', data);
    }

    site_ad() {
        return this.__get_resp('/api/spreadinfo/get_spread_info', {});
    }

    /*
     *分类筛选分类 
    */
    get_classify() {
        return this.__get_resp('/cg_api/book/category', {});
    }

    /*
     * 分类筛选列表 
     * s_channel
     * tag
     * progress
     * sort
     * page
     * words
     */
    filter_list(data) {
        return this.__get_resp('/cg_api/book/search', data);
    }

    /*
     *书架 
    */
    @check_login
    get_bookrack() {
        return this.__get_resp('/user/bcView', { display: 'json' }).catch(e => {
            if (e.collect_log) {
                return e;
            } else {
                throw e;
            }
        });
    }

    logout() {
        return this.__get_resp('/user/logout', {});
    }

    /*
     * novel_id
     */
    @check_login
    add_collect(data) {
        const { novel_id } = data;
        return this.__get_resp('/book/add_book/' + novel_id, {});
    }

}


export default new Wandu();



// WEBPACK FOOTER //
// ./src/service/wandu.js